export default [
    {path: '/organizations/:id/edit', screen: 'organization/EditOrganization', secured: true, role: ['admin']},
    {path: '/organizations/:id', screen: 'organization/DisplayOrganization', secured: true, role: ['admin']},
    {path: '/organizations', screen: 'organization/ListOrganizations', secured: true, role: ['admin']},
    {path: '/organization/new', screen: 'organization/CreateOrganization', secured: true, role: ['admin']},
]